import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "flex text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "space-y-2" }
const _hoisted_4 = { class: "ml-2 flex items-center space-x-4" }
const _hoisted_5 = {
  key: 0,
  class: "mt-4 flex bg-gray-50 px-4 py-4 shadow ring-1 ring-gray-300 sm:p-6 md:rounded"
}
const _hoisted_6 = { class: "w-full border-collapse text-sm" }
const _hoisted_7 = { class: "sticky top-0 bg-gray-200 text-gray-800" }
const _hoisted_8 = { class: "align-center p-4" }
const _hoisted_9 = { class: "flex flex-1 items-center" }
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { class: "font-semibold text-gray-800" }
const _hoisted_12 = { class: "text-sm text-gray-400" }
const _hoisted_13 = { class: "flex flex-col items-center justify-center space-y-1 px-1 py-2" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "align-center p-4" }
const _hoisted_16 = { class: "flex justify-center gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiSpinner = _resolveComponent("UiSpinner")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiListSearch = _resolveComponent("UiListSearch")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _component_UiBadge = _resolveComponent("UiBadge")!
  const _component_UiActionButton = _resolveComponent("UiActionButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('report.realtimeAgentExtension.title')) + " ", 1 /* TEXT */),
          ($setup.isLoading)
            ? (_openBlock(), _createBlock(_component_UiSpinner, {
                key: 0,
                class: "theme-color ml-2 h-6 w-6"
              }))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_UiPanel, {
        class: "flex px-4 py-2",
        "no-padding": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_UiListSearch, {
            modelValue: $setup.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.search) = $event))
          }, null, 8 /* PROPS */, ["modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode($setup["AgentExtensionReportSort"], {
              modelValue: $setup.sortMenuSelected,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.sortMenuSelected) = $event))
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createVNode($setup["AgentExtensionReportFilters"])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    ($setup.activeFilters.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activeFilters, (filter) => {
            return (_openBlock(), _createBlock(_component_UiBadge, {
              key: filter,
              removable: "",
              onRemove: ($event: any) => ($setup.handleRemoveFilter(filter))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`report.realtimeAgentExtension.filters.activeTag.${filter.field}`)) + " " + _toDisplayString(filter.label), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onRemove"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_UiPanel, { "no-padding": "" }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", _hoisted_7, [
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.tableHeaders, (header) => {
                return _createElementVNode("th", {
                  key: header.key,
                  class: _normalizeClass(["p-4", header.align === 'center' ? 'text-center' : 'text-left'])
                }, _toDisplayString(_ctx.$t(header.label)), 3 /* TEXT, CLASS */)
              }), 64 /* STABLE_FRAGMENT */))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.computedUserTableRows, (row) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: row.user.id,
                class: "even:bg-gray-100"
              }, [
                _createCommentVNode(" Name "),
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode($setup["UserIcon"], { class: "mr-2 h-12 w-12 rounded-full border border-gray-300 bg-gray-50 p-0.5 text-gray-400 shadow" }),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(row.user.name), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_12, " Ramal " + _toDisplayString(row.user.extension?.number), 1 /* TEXT */)
                    ])
                  ])
                ]),
                _createCommentVNode(" Devices "),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.deviceTypes, (deviceType) => {
                  return _createElementVNode("td", {
                    key: deviceType,
                    class: "align-center p-4 text-center"
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      (row.devices[deviceType])
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: _normalizeClass([
                                        $setup.connectedUserDeviceStatuses.has(
                                            row.devices[deviceType]?.state
                                                ?.status as UserDeviceStatus,
                                        )
                                            ? 'bg-success-50 border-success-800 text-success-700'
                                            : 'bg-danger-50 border-danger-800 text-danger-700',
                                        'grid grid-cols-1 gap-1 rounded border-2 border-opacity-15 bg-gray-50 px-1 py-0.5 pt-1 text-center text-xs font-semibold',
                                    ])
                          }, _toDisplayString(_ctx.$t(
                                            `report.realtimeAgentExtension.device.status.${
                                                row.user?.queueStatusHistory?.length
                                                    ? $setup.UserDeviceStatus.IN_PAUSE
                                                    : row.devices[deviceType]?.status ||
                                                      $setup.UserDeviceStatus.OFFLINE
                                            }`,
                                        )), 3 /* TEXT, CLASS */))
                        : (_openBlock(), _createElementBlock("p", _hoisted_14, "-"))
                    ])
                  ])
                }), 64 /* STABLE_FRAGMENT */)),
                _createCommentVNode(" Queues "),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.user.queues, (queue) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: queue.id,
                          class: "flex gap-1"
                        }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(
                                                _ctx.$can($setup.Permission.VIEW_QUEUE) ? 'RouterLink' : 'span'
                                            ), {
                            to: {
                                                name: 'ViewQueueById',
                                                params: {
                                                    id: queue?.id,
                                                },
                                            },
                            class: "text-primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(queue.name), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    (row.user.queues?.length && _ctx.$can($setup.Permission.EDIT_QUEUE))
                      ? (_openBlock(), _createBlock(_component_UiActionButton, {
                          key: 0,
                          variant: "primary",
                          "text-variant": "primary",
                          onClick: ($event: any) => ($setup.toggleQueueMemberPause(row.user.id))
                        }, {
                          default: _withCtx(() => [
                            (!row.user?.queueStatusHistory?.length)
                              ? (_openBlock(), _createBlock($setup["PauseIcon"], {
                                  key: 0,
                                  class: "h-7 w-7"
                                }))
                              : (_openBlock(), _createBlock($setup["PlayIcon"], {
                                  key: 1,
                                  class: "h-7 w-7"
                                })),
                            _createElementVNode("span", null, _toDisplayString(row.user?.queueStatusHistory?.length
                                            ? $setup.t('report.realtimeAgentExtension.actions.unpause')
                                            : $setup.t('report.realtimeAgentExtension.actions.pause')), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}